import { useEffect, useState } from "react";
import { EVENT_BUS_EVENTS } from "../util/useEventBus";
import { affordances } from "../util/analytics";
import { addErrorNotification } from "../store/actions";

// when the content MFE is loaded, send out an event to request
// the release of any LAUNCH_CONTENT_TABLE
// inmate events stored in the mfe-container's event bus jail
// then receive the event context and store it temporarily in state
// then when everything is finished loading, we can launch the requested table dialog
export default function useEventBusJail(
  eventBus,
  isDialogOpen,
  hasData,
  tablesContent,
  isNonFreePreview,
  setTableData,
  setIsDialogOpen,
  openTableCTA,
  dispatch
) {
  const [
    hasRequestedTableInmateEvent,
    setHasRequestedTableInmateEvent,
  ] = useState(false);
  const [
    clinicalCollectionsTableToOpenData,
    setClinicalCollectionsTableToOpenData,
  ] = useState(undefined);

  useEffect(() => {
    if (
      !isDialogOpen &&
      hasData &&
      tablesContent &&
      Object.keys(tablesContent).length > 0 &&
      !hasRequestedTableInmateEvent
    ) {
      eventBus.emit(EVENT_BUS_EVENTS.POST_BAIL_FOR_INMATE, null, {
        requestingMfe: "content",
        inmateEventRequested: EVENT_BUS_EVENTS.LAUNCH_CONTENT_TABLE,
      });
      setHasRequestedTableInmateEvent(true);
    }
  }, [
    isDialogOpen,
    hasData,
    tablesContent,
    hasRequestedTableInmateEvent,
    eventBus,
  ]);
  useEffect(() => {
    eventBus.on(EVENT_BUS_EVENTS.LAUNCH_CONTENT_TABLE, (context) => {
      setClinicalCollectionsTableToOpenData(context);
      eventBus.detach(EVENT_BUS_EVENTS.LAUNCH_CONTENT_TABLE);
    });
  }, [eventBus]);

  useEffect(() => {
    if (
      !isDialogOpen &&
      hasData &&
      tablesContent &&
      clinicalCollectionsTableToOpenData
    ) {
      const { tableTitle, tableId } = clinicalCollectionsTableToOpenData;
      if (tableTitle && tableId && tablesContent[tableId]) {
        if (isNonFreePreview) {
          return openTableCTA();
        } else {
          setTableData({
            isStandAlone: true,
            title: tableTitle,
            tableId,
            children: tablesContent[tableId],
            affordance: affordances.TABLE_CLINICAL_COLLECTIONS,
            navigateFrom: affordances.TABLE_CLINICAL_COLLECTIONS,
          });
          setIsDialogOpen(true);
        }
        setClinicalCollectionsTableToOpenData(undefined);
      } else {
        addErrorNotification(
          dispatch,
          "We're sorry, something went wrong. Please try again later."
        );
      }
    }
  }, [
    clinicalCollectionsTableToOpenData,
    hasData,
    tablesContent,
    isDialogOpen,
    isNonFreePreview,
    openTableCTA,
    setTableData,
    setIsDialogOpen,
    setClinicalCollectionsTableToOpenData,
    dispatch,
  ]);
}
